"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultCellSize = exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _classnames = _interopRequireDefault(require("classnames"));

var _PaginationComponent = _interopRequireDefault(require("../../control-components/ui-components/PaginationComponent"));

var _Checkbox = _interopRequireDefault(require("@insided/shared/uikit/Checkbox"));

var _Tooltip = _interopRequireDefault(require("@insided/shared/uikit/Tooltip"));

var _TextButton = _interopRequireDefault(require("../../control-components/ui-components/TextButton"));

var _Question = _interopRequireDefault(require("@insided/destination/icons/Question"));

var _Sorting = _interopRequireDefault(require("./Sorting"));

var _Row = _interopRequireDefault(require("./Row"));

var _reactSortableHoc = require("react-sortable-hoc");

var _excluded = ["model", "rows", "rowId", "sort", "onSortChange", "narrow", "classes", "style", "withPagination", "actionElements", "firstColumnSticky", "staticWidth", "withMultiSelect", "selectedRows", "allSelected", "onSelectRow", "onSelectAll", "onClearSelection", "entity", "bulkActions", "sortableTabsIndex", "dragDropFunctionality", "onSortStart", "onSortEnd"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var defaultCellSize = 'm';
exports.defaultCellSize = defaultCellSize;
var SortableItem = (0, _reactSortableHoc.SortableElement)(function (_ref) {
  var children = _ref.children;
  return children;
});

var shouldShowActionBar = function shouldShowActionBar(_ref2) {
  var withPagination = _ref2.withPagination,
      actionElements = _ref2.actionElements,
      selectedRows = _ref2.selectedRows,
      _ref2$isActionBarVisi = _ref2.isActionBarVisible,
      isActionBarVisible = _ref2$isActionBarVisi === void 0 ? true : _ref2$isActionBarVisi;

  if (!isActionBarVisible) {
    return false;
  }

  if (selectedRows && selectedRows.length > 0) {
    return true;
  }

  return !!(withPagination !== null && withPagination !== void 0 ? withPagination : actionElements);
};

var Table = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Table, _Component);

  var _super = _createSuper(Table);

  function Table() {
    (0, _classCallCheck2.default)(this, Table);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(Table, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          model = _this$props.model,
          rows = _this$props.rows,
          rowId = _this$props.rowId,
          sort = _this$props.sort,
          onSortChange = _this$props.onSortChange,
          narrow = _this$props.narrow,
          _this$props$classes = _this$props.classes,
          classes = _this$props$classes === void 0 ? [] : _this$props$classes,
          _this$props$style = _this$props.style,
          style = _this$props$style === void 0 ? {} : _this$props$style,
          withPagination = _this$props.withPagination,
          actionElements = _this$props.actionElements,
          _this$props$firstColu = _this$props.firstColumnSticky,
          firstColumnSticky = _this$props$firstColu === void 0 ? false : _this$props$firstColu,
          _this$props$staticWid = _this$props.staticWidth,
          staticWidth = _this$props$staticWid === void 0 ? false : _this$props$staticWid,
          withMultiSelect = _this$props.withMultiSelect,
          selectedRows = _this$props.selectedRows,
          allSelected = _this$props.allSelected,
          onSelectRow = _this$props.onSelectRow,
          onSelectAll = _this$props.onSelectAll,
          onClearSelection = _this$props.onClearSelection,
          entity = _this$props.entity,
          bulkActions = _this$props.bulkActions,
          _this$props$sortableT = _this$props.sortableTabsIndex,
          sortableTabsIndex = _this$props$sortableT === void 0 ? 0 : _this$props$sortableT,
          _this$props$dragDropF = _this$props.dragDropFunctionality,
          dragDropFunctionality = _this$props$dragDropF === void 0 ? false : _this$props$dragDropF,
          onSortStart = _this$props.onSortStart,
          onSortEnd = _this$props.onSortEnd,
          otherProps = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      var useObjectModel = model && Object.prototype.hasOwnProperty.call(model[0], 'header');
      var showActionBar = shouldShowActionBar(this.props);
      return (0, _preact.h)("div", {
        className: "control-table"
      }, showActionBar && (0, _preact.h)("div", {
        className: "action-bar-wrapper"
      }, selectedRows && selectedRows.length > 0 ? (0, _preact.h)("div", {
        className: "action-bar"
      }, (0, _preact.h)("div", {
        className: "control-table__selected"
      }, (0, _preact.h)("div", {
        className: "control-table__selected-count"
      }, selectedRows.length, " ", selectedRows.length > 1 ? entity : entity === null || entity === void 0 ? void 0 : entity.slice(0, -1), " selected"), (0, _preact.h)(_TextButton.default, {
        className: "control-table__clear-selection",
        onClick: onClearSelection
      }, "Clear selection")), bulkActions && bulkActions) : (0, _preact.h)("div", {
        className: "action-bar"
      }, actionElements && actionElements, withPagination && (0, _preact.h)(_PaginationComponent.default, withPagination))), (0, _preact.h)("div", {
        className: (0, _classnames.default)('table-wrapper', {
          'with-action-bar': showActionBar
        })
      }, (0, _preact.h)("table", {
        className: _classnames.default.apply(void 0, [{
          narrow: narrow
        }].concat((0, _toConsumableArray2.default)(classes))),
        style: style
      }, (0, _preact.h)("thead", null, (0, _preact.h)("tr", null, withMultiSelect && (0, _preact.h)("th", {
        className: "fixed-column-header table-header--multiselect"
      }, (0, _preact.h)(_Checkbox.default, {
        qaClasses: "control-table__select_all",
        onUpdate: function onUpdate() {
          return onSelectAll === null || onSelectAll === void 0 ? void 0 : onSelectAll();
        },
        checked: !!allSelected
      })), dragDropFunctionality && (0, _preact.h)("th", {
        className: "fixed-column-header table-header--drag"
      }), model ? Object.keys(model).map(function (key) {
        var _model$Number$size;

        if (model[Number(key)].isHidden) {
          return null;
        }

        return (0, _preact.h)("th", {
          key: key,
          className: "".concat((_model$Number$size = model[Number(key)].size) !== null && _model$Number$size !== void 0 ? _model$Number$size : defaultCellSize, " ").concat(firstColumnSticky && key === '0' ? 'fixed-column-header' : '')
        }, !Object.prototype.hasOwnProperty.call(model[Number(key)], 'sorting') && (0, _preact.h)("div", {
          className: "table-header-cell table-header-cell-".concat(model[Number(key)].accessor)
        }, useObjectModel ? model[Number(key)].header : model[Number(key)], Object.prototype.hasOwnProperty.call(model[Number(key)], 'tooltipMessage') && (0, _preact.h)(_Tooltip.default, {
          trigger: (0, _preact.h)(_Question.default, {
            width: 16,
            height: 16
          }),
          tooltipMessage: "".concat(model[Number(key)].tooltipMessage),
          withArrow: true,
          position: "center",
          noWrap: true,
          top: 24
        })), Object.prototype.hasOwnProperty.call(model[Number(key)], 'sorting') && (0, _preact.h)("div", (0, _extends2.default)({
          role: "button",
          tabIndex: sortableTabsIndex,
          className: "table-header-cell table-header-cell-".concat(model[Number(key)].accessor, " sortable"),
          onClick: function onClick() {
            var _model$Number$sorting;

            return onSortChange === null || onSortChange === void 0 ? void 0 : onSortChange((_model$Number$sorting = model[Number(key)].sorting) !== null && _model$Number$sorting !== void 0 ? _model$Number$sorting : '');
          }
        }, otherProps), useObjectModel ? model[Number(key)].header : model[Number(key)], Object.prototype.hasOwnProperty.call(model[Number(key)], 'tooltipMessage') && (0, _preact.h)(_Tooltip.default, {
          trigger: (0, _preact.h)(_Question.default, {
            width: 16,
            height: 16
          }),
          tooltipMessage: "".concat(model[Number(key)].tooltipMessage),
          withArrow: true,
          position: "center",
          noWrap: true,
          top: 24
        }), (0, _preact.h)(_Sorting.default, {
          direction: sort === null || sort === void 0 ? void 0 : sort.direction,
          isEnabled: (sort === null || sort === void 0 ? void 0 : sort.order) === model[Number(key)].sorting
        })));
      }) : rows[0].map(function (key) {
        var _key$size;

        return (0, _preact.h)("th", {
          key: key.accessor,
          className: "".concat((_key$size = key.size) !== null && _key$size !== void 0 ? _key$size : defaultCellSize, " ").concat(firstColumnSticky && key.size === '0' ? 'fixed-column-header' : '')
        }, (0, _preact.h)("div", {
          className: "table-header-cell-".concat(key.accessor, " ")
        }, key.header));
      }))), (0, _preact.h)("tbody", null, dragDropFunctionality ? Object.keys(rows).map(function (key, index) {
        return (0, _preact.h)(SortableItem, {
          index: index,
          key: key
        }, (0, _preact.h)(_Row.default, {
          key: key,
          displayFirstColumnBold: firstColumnSticky,
          id: rowId,
          cells: rows[Number(key)],
          model: useObjectModel ? model : null,
          isSelectable: withMultiSelect,
          isSelected: selectedRows && !!rowId && selectedRows.includes(rows[Number(key)][rowId]),
          onSelectRow: onSelectRow,
          dragDropFunctionality: true
        }));
      }) : Object.keys(rows).map(function (key) {
        return (0, _preact.h)(_Row.default, {
          key: key,
          displayFirstColumnBold: firstColumnSticky,
          id: rowId,
          cells: rows[Number(key)],
          model: useObjectModel ? model : null,
          isSelectable: withMultiSelect,
          isSelected: selectedRows && !!rowId && selectedRows.includes(rows[Number(key)][rowId]),
          onSelectRow: onSelectRow
        });
      })))));
    }
  }]);
  return Table;
}(_preact.Component);

var _default = Table;
exports.default = _default;